module.exports = __webpack_public_path__ + "assets/719fc00e539289609c00b1ce355b40a5.mp3";